import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Welcome from "@/pages/Welcome";
import Dashboard from "@/pages/Dashboard";
import Lesson from "@/pages/Lesson";
import ConceptLesson from "@/pages/ConceptLesson";
import Badges from "@/pages/Badges";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import VerifyCertificate from "@/pages/VerifyCertificate";
import SpinningWheel from "@/pages/SpinningWheel";
import FinalAssessment from "@/pages/FinalAssessment";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/concept/:conceptId" element={<ConceptLesson />} />
          <Route path="/lesson/:lessonId" element={<Lesson />} />
          <Route path="/badges" element={<Badges />} />
          <Route path="/challenges" element={<SpinningWheel />} />
          <Route path="/assessment" element={<FinalAssessment />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/verify/:certId" element={<VerifyCertificate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
